import React, { FC } from 'react';
import Money from '../../../../../../../Money';
import cn from 'classnames';
import { Money as MoneyType } from '../../../../../../../types';
import { useTheme } from '../../../../../../../theme';
import { CheckinCardItem } from '@shared/CheckinCard';

export interface Props {
	name: string;
	price: MoneyType;
	isMinus?: boolean;
	className?: string;
	delimiter?: 'line' | 'dashed';
}

export const PriceItem: FC<Props> = ({ name, price, isMinus, delimiter, className }) => {
	const { PriceItem: css } = useTheme('Entities').Order.ExchangeRefundPriceDetails;

	const priceWithoutMinus = price?.amount ? Math.abs(price?.amount) : 0;
	const showSing = isMinus && priceWithoutMinus > 0;

	return (
		<CheckinCardItem
			className={cn(css.root, className)}
			delimiter={delimiter ? 'line' : undefined}
			delimiterGap={!!delimiter}
		>
			<div className={css.title}>{name}</div>
			<div>
				{!!showSing && <span>-</span>}
				<Money money={{ ...price, amount: priceWithoutMinus }} />
			</div>
		</CheckinCardItem>
	);
};

export default PriceItem;
